export type ThemeMode = 'light' | 'dark';

export type ListingId = 'fourways' | 'casagrande';

export type Photo = {
  caption: string;
  jpgSrcSet: string;
  webpSrcSet: string;
  fallback: string;
  maxWidth: number;
};

/** Approximate area used by the neighbourhood map — never the exact street address. */
export type AreaCenter = { lat: number; lng: number };

export type Listing = {
  id: ListingId;
  airbnbUrl: string;
  guests: number;
  bedrooms: number;
  beds: number;
  /** half-baths supported via decimal (e.g. 2.5) */
  baths: number;
  /** optional — only renders when the host populates real values from Airbnb */
  rating?: number;
  reviews?: number;
  price: number;
  minNights: number;
  photos: Photo[];
  /** Center of the obscuring map circle — offset from the actual home. */
  area: AreaCenter;
  amenityKeys: readonly string[];
  nearbyKeys: readonly string[];
};

export const SUPPORTED_LANGUAGES = ['en', 'fr', 'de', 'es', 'it', 'pt'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const LANGUAGE_LABELS: Record<SupportedLanguage, string> = {
  en: 'English',
  fr: 'Français',
  de: 'Deutsch',
  es: 'Español',
  it: 'Italiano',
  pt: 'Português',
};
